const inIframe = () => window.self !== window.top;

export { inIframe };
